import { createSlice } from "@reduxjs/toolkit";
import { RootState } from ".";
import { StoreState } from "@models/StoreState";
import { CATEGORIES } from "@utils/constants";
const initialState: StoreState = {
  overviewItems: {
    lastUpdate: "",
    totaux: [],
    camembert: [],
  },
  currentCategory: CATEGORIES.TOTAL,
  currentYear: "06/2026",
  regions: [],
};

export const mainSlice = createSlice({
  name: "M",
  initialState,
  reducers: {
    setOverviewItems: (state, action) => {
      state.overviewItems = action.payload;
    },
    setCurrentCategory: (state, action) => {
      state.currentCategory = action.payload;
    },
    setCurrentYear: (state, action) => {
      state.currentYear = action.payload;
    },
    setRegions: (state, action) => {
      state.regions = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setOverviewItems,
  setCurrentCategory,
  setRegions,
  setCurrentYear,
} = mainSlice.actions;

export const selectCurrentCategory = (state: RootState) =>
  state.main.currentCategory;

export const selectOverviewItems = (state: RootState) =>
  state.main.overviewItems;
export const selectRegions = (state: RootState) => state.main.regions;
export const selectCurrentYear = (state: RootState) => state.main.currentYear;

export default mainSlice.reducer;
